import { Conversation, ConversationItem } from "@accurx/concierge/types";

export const getConversationDescription = (
    conversation: Conversation,
): ConversationItem["contentType"] => {
    const { items } = conversation;
    return items[0]?.contentType;
};
